export interface MetadataOptions {
  url: string;
  extern?: boolean;
}
